angular.module('lsnBase.deprecated.models')
  .factory('OrganizationModelConstants', ['LsnOrganizationModelConstants', function(LsnOrganizationModelConstants) {
    return LsnOrganizationModelConstants;
  }])
  .factory('OrganizationModel', ['LsnOrganizationModelV1',
    function(LsnOrganizationModelV1) {
      return LsnOrganizationModelV1;
    }
  ]);